import React from "react";
import { withStyles, Switch } from "@material-ui/core";
import { connect } from "react-redux";
import { changeShopStatus, changeItemStatus } from "../../actions/authActions";

const PurpleSwitch = withStyles({
  switchBase: {
    color: "green",
    "&$checked": {
      color: "green",
    },
    "&$checked + $track": {
      backgroundColor: "green",
    },
  },
  checked: {},
  track: {},
})(Switch);

class SwitchClass extends React.Component {
  state = {
    checkedA: this.props.switch,
  };

  handleChange(event) {
    if (this.props.shop) {
      this.props.changeShopStatus(this.props.sellerID, event.target.checked);
      this.setState({
        ...this.state,
        [event.target.name]: event.target.checked,
      });
    }

    if (this.props.item) {
      // BUG: Check this, and add _ in case of error
      this.props.changeItemStatus(this.props.id, event.target.checked);
      this.setState({
        ...this.state,
        [event.target.name]: event.target.checked,
      });
    }
  }

  render() {
    return (
      <PurpleSwitch
        edge="end"
        checked={this.state.checkedA}
        onChange={(event) => {
          if (this.props.shop) {
            this.props.changeShopStatus(
              this.props.sellerID,
              event.target.checked
            );
            this.setState({
              ...this.state,
              [event.target.name]: event.target.checked,
            });
          }
          if (this.props.item) {
            this.props.changeItemStatus(this.props.id, event.target.checked);
            window.location.reload()
            this.setState({
              ...this.state,
              [event.target.name]: event.target.checked,
            });
          }
        }}
        name="checkedA"
      />
    );
  }
}

export default connect(null, { changeItemStatus, changeShopStatus })(
  SwitchClass
);
